// extracted by mini-css-extract-plugin
export default {"review__image":"ImageProductReview_review__image__5eUWK","review__image--setup":"ImageProductReview_review__image--setup__E5KQM"};